{
  "gitSha": "9db338f23825bf4a6cf916fc42e044fa065bc5c6",
  "gitShaShort": "9db338",
  "packageVersion": "1.162.0",
  "sentryRelease": "9db338f23825bf4a6cf916fc42e044fa065bc5c6",
  "buildStartedAt": "2025-05-28T10:02:11+02:00"
}